// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#flex-container {
    display: flex;
    max-width: 90%;
    margin: auto;
    margin-bottom: 30px;
    gap: 70px;
    font-size: 1vw;

}

#submit-paragraph {
    font-size: 1.3vw;
    font-weight: 700;
}

#flex-left {
  flex: 3 1;
}

#flex-right {
  flex: 2.5 1;
  margin-top: 20px;
   
}

#select-file {
    display: flex;
    gap: 15px;
    align-items: center;
    margin-bottom: 50px;
    font-size: 1.3vw;
}

#select-file input {
    font-size: 0.9vw;
}

#metadata {
    font-size: 1.3vw;
}

#meta-text {
    display: block;
    font-size: 1vw;
}

#metadata textarea {
    margin: 10px 0;
    max-width: 30em;
    max-height: 400px;
    font-family: sans-serif, Arial, Helvetica;
    padding: 10px;
    letter-spacing: px;
}

button {
    margin-top: 1em;
    padding: 1em 2em;
    font-size: 1vw;;
    color: white;
    background-color: #3a89c9;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    letter-spacing: 1.2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Submit.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAS;EACT,gBAAgB;;AAElB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB","sourcesContent":["#flex-container {\n    display: flex;\n    max-width: 90%;\n    margin: auto;\n    margin-bottom: 30px;\n    gap: 70px;\n    font-size: 1vw;\n\n}\n\n#submit-paragraph {\n    font-size: 1.3vw;\n    font-weight: 700;\n}\n\n#flex-left {\n  flex: 3;\n}\n\n#flex-right {\n  flex: 2.5;\n  margin-top: 20px;\n   \n}\n\n#select-file {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    margin-bottom: 50px;\n    font-size: 1.3vw;\n}\n\n#select-file input {\n    font-size: 0.9vw;\n}\n\n#metadata {\n    font-size: 1.3vw;\n}\n\n#meta-text {\n    display: block;\n    font-size: 1vw;\n}\n\n#metadata textarea {\n    margin: 10px 0;\n    max-width: 30em;\n    max-height: 400px;\n    font-family: sans-serif, Arial, Helvetica;\n    padding: 10px;\n    letter-spacing: px;\n}\n\nbutton {\n    margin-top: 1em;\n    padding: 1em 2em;\n    font-size: 1vw;;\n    color: white;\n    background-color: #3a89c9;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    letter-spacing: 1.2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
